import { defineComponent as _defineComponent } from 'vue'
import { computed, reactive, ref, Ref, watch } from 'vue';
import { useColor } from '@/composables/color';
import { useClickOutside } from '@/composables/clickOutside';
import ColorSelector from '../ColorSelector.vue';
import CButtonGroup, { type CButtonGroupItem } from '@/components/shared/CButtonGroup';
import type { FontColorOption, ImagePlaceholderElement, WordCloudConfig } from '@/typings/customilyElements/canvasElements';
import type { ColorObject } from '@/typings/libraries';


export default /*#__PURE__*/_defineComponent({
  __name: 'ColorProperties',
  props: {
    imageElement: null,
    editMode: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
    imageElement?: ImagePlaceholderElement;
    editMode?: boolean;
};

const DEFAULT_BG_COLOR: ColorObject = { hex: '#000000', alpha: 1, cmyk: '' };

const COLOR_MODES: CButtonGroupItem<boolean>[] = [
    {
        label: 'Use image colors',
        value: true
    },
    {
        label: 'Use default colors',
        value: false
    }
];

const BG_MODES: CButtonGroupItem<boolean>[] = [
    {
        label: 'Transparent Background',
        value: true
    },
    {
        label: 'Choose Color',
        value: false
    }
];



const disabled = computed(() => !!props.imageElement?.locked);

const model = reactive({
    useImageColors: true,
    transparentBackground: true,
    bgColor: undefined as ColorObject | undefined
});

const { getColorFromString, hexToHexa } = useColor();
watch(
    () => props.imageElement,
    (element) => {
        if (!element || !element.wordCloudConfig) return;

        const config = element.wordCloudConfig;
        model.useImageColors = config.useImageColors ?? true;
        model.transparentBackground = !config.bgColor;
        model.bgColor = undefined;

        if (config.bgColor) {
            const color = getColorFromString(config.bgColor);
            model.bgColor = {
                hex: color.hex,
                alpha: color.a,
                cmyk: ''
            }
        }

    },
    { immediate: true }
);


const pickerRef: Ref<HTMLElement | undefined> = ref();
const { clickOutsideActive } = useClickOutside(pickerRef, () => toggleColorSelection(), false);
const toggleColorSelection = () => {
    clickOutsideActive.value = !clickOutsideActive.value;
};

const onBgModeChanged = () => {
    if (!model.transparentBackground) {
        onBgColorSelected(DEFAULT_BG_COLOR);
        clickOutsideActive.value = false;
        return;
    }
    model.bgColor = undefined;
    updateWordCloudConfig({ bgColor: undefined });
};

const onBgColorSelected = (color: FontColorOption) => {
    model.bgColor = { ...color } as ColorObject;
    updateWordCloudConfig({ bgColor: hexToHexa(model.bgColor.hex, model.bgColor.alpha) });
    toggleColorSelection();
};


const updateWordCloudConfig = (config: Partial<WordCloudConfig>) => {
    const element = props.imageElement;
    if (!element) return;

    const newConfig = { ...element.wordCloudConfig, ...config } as WordCloudConfig;
    element.set('wordCloudConfig', newConfig);
    if (props.editMode) element.setEditedProp('wordCloudConfig');
};

return { __sfc: true,DEFAULT_BG_COLOR, COLOR_MODES, BG_MODES, props, disabled, model, getColorFromString, hexToHexa, pickerRef, clickOutsideActive, toggleColorSelection, onBgModeChanged, onBgColorSelected, updateWordCloudConfig, ColorSelector, CButtonGroup }
}

})